import store from '@/store'
import {Message, MessageBox} from 'element-ui'
import i18n from "@/lang";
import {getMinPayAmount} from "@/api/card";
import router from "@/router";
import {needsReconciliationAmount} from "@/api/settlement"; // 根据你的i18n配置引入

/**
 * 绑卡提示公共方法
 * @param {string} type - 类型：'init'（初始化检查）
 * @returns {Promise<boolean>} 返回是否有绑卡
 */
export async function balancePrompt(type) {
  // 判断当前会话期间是否提醒过
  if (type === 'init') {
    const bingCardPrompt = sessionStorage.getItem('balancePrompt')
    if (bingCardPrompt) return true
  }
  
  try {
    const {code, data} = await needsReconciliationAmount()
    let balanceAmount = false
    if (code === 200 && data && data.amount <= 0) {
      balanceAmount = true
    }
    sessionStorage.setItem('balancePrompt', 'true')
    
    if (!balanceAmount) return true
    
    // 获取 Vuex 中的状态
    const state = store.state.user
    const managerFlag = state.managerFlag
    const shelfName = state.shelfName
    
    if (managerFlag) {
      // 管理者：显示确认对话框
      return new Promise((resolve) => {
        MessageBox.confirm(
          i18n.t('wallet.bingCardTipSeller').replace('x', shelfName),
          i18n.t('entry.prompt'),
          {
            confirmButtonText: i18n.t('wallet.bindNow'),
            showCancelButton: false,
            closeOnClickModal: false,
            type: 'warning'
          }
        ).then(() => {
          // 用户点击确认，跳转到账户中心
          router.push('/fund/billManagement')
          resolve(false)
        }).catch(() => {
          resolve(false)
        })
      })
    } else {
      Message.warning(
        (i18n.t('wallet.bingCardTipOperator')
          .replace('x', shelfName))
      );
      return false
    }
  } catch (error) {
    return true
  }
}


// WEBPACK FOOTER //
// ./src/views/fund/accountCenter/bingCardPrompt.js